import { render } from "./pre-payment-info-box.component.vue?vue&type=template&id=189918ee&ts=true"
import script from "./pre-payment-info-box.component.vue?vue&type=script&lang=ts"
export * from "./pre-payment-info-box.component.vue?vue&type=script&lang=ts"

import "./pre-payment-info-box.component.vue?vue&type=style&index=0&id=189918ee&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__